// Demo site (Try Teamio) — LogRocket for a demo session (plan Task 6.6, design 2d-5; Saumil 2026-10-02: record ALL
// demo sessions). handleSelectSite asks this BEFORE the real-user block (25% sticky sampling per EmployeeID), which
// it skips for a demo session: the four personas are shared by every prospect, so sampling or identifying by the
// persona's EmployeeID would mix leads together. Demo data is fake, so a recording holds no patient data.
// Recording starts at the link sign-in (/demo/redeem), never on a bare /try page load.
// src/store/__tests__/logrocket-sampling.test.js executes this file.
import { personaForEmployee } from './demoShell';

/** The same LogRocket app as the real-user block in store/customer.js (a test keeps them equal). */
export const LOGROCKET_APP_ID = 'on9gpj/teamio';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * What handleSelectSite does with LogRocket:
 *   null                                    not a demo session — the real-user block decides, as before
 *   { record: false }                       a demo session that is not recorded (not prod, or no prospect id);
 *                                           the real-user block is still skipped
 *   { record: true, appID, userID, traits } init once per page, identify the PROSPECT (the token's prospectID)
 */
export function demoLogRocketPlan({ isDemo, host, prospectID, employeeID }) {
  if (isDemo !== true) return null;
  if (typeof host !== 'string' || !host.includes('prod.teamio.app')) return { record: false };
  if (typeof prospectID !== 'string' || !UUID.test(prospectID)) return { record: false };
  const persona = personaForEmployee(employeeID);
  return {
    record: true,
    appID: LOGROCKET_APP_ID,
    userID: prospectID,
    traits: { demo: true, prospectID, persona: persona ? persona.key : 'unknown' },
  };
}
